import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	selectAllCheckboxLabel: {
		id: 'issue-table.common.fields.checkbox.header.select-all-checkbox-label',
		defaultMessage: 'Select all issues',
		description: 'Aria label for checkbox that selects all issues in the table.',
	},
});
